// Full surface: types + factory + safe default. Unlike the memory provider,
// nothing here pulls a server-only dependency chain (the Bedrock concrete is
// injected by its consumer), so the barrel can carry the factory too.
export type { ComposerLlm, ComposerLlmInput } from './types';
export { noopComposerLlm } from './noop';
export { getComposerLlm } from './select';
